module.exports = __webpack_public_path__ + "img/2020_badge.694f9fdc.png";